import axios from "axios";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import "./css/main.login.css";
import Register from "../register/Register";
import { getAssetUrl } from "../../utils/assetUrl";

const Login: React.FC = () => {
  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [showLoadingVideo, setShowLoadingVideo] = useState(false);
  const [loadingPercent, setLoadingPercent] = useState(0);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    } else if (userName.trim() != "" || password.trim() != "") {
      try {
        Swal.fire({
          title: "Đang xử lý...",
          html: "<p class='swal-loading-subtext'>Vui lòng chờ trong giây lát</p><div class='swal-loading-dots'><span class='swal-dot swal-dot-cyan'></span><span class='swal-dot swal-dot-orange'></span></div>",
          customClass: {
            popup: "custom-swal swal-loading-modal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        // Chờ 3 giây
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await axios
          .post(`${process.env.REACT_APP_URL_API}/auth/login`, {
            username: userName,
            password,
          })
          .then(async (data) => {
            localStorage.setItem(
              "user_info",
              JSON.stringify({
                userName: data.data.user.username,
                coins: data.data.user.coins,
                role: data.data.user.role,
                id: data.data.user._id,
              })
            );

            Cookies.set("access_token", data.data.access_token, {
              expires: 1 / 24,
              secure: false, // Thử false cho iOS
              sameSite: "Lax", // Thử Lax thay vì Strict
            });

            await new Promise((resolve) => setTimeout(resolve, 100));

            if (
              data.status === 201 &&
              (data.data.user.role === "SUPERADMIN" ||
                data.data.user.role === "ADMIN")
            ) {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/admin";
              }, 500);
            } else {
              Swal.close();
              setShowLoadingVideo(true);
            }
          })
          .catch((err) => {
            if (err.status === 401) {
              Swal.fire({
                icon: "error",
                title: "Lỗi đăng nhập",
                text: "Tài khoản/mật khẩu không chính xác!",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
            }
          });
      } catch (error) {
        return error;
      }
    }
  };

  useEffect(() => {
    if (showLoadingVideo) {
      setLoadingPercent(0);

      const startTime = Date.now();
      const duration = 5000;

      const interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(100, Math.round((elapsed / duration) * 100));
        setLoadingPercent(progress);
      }, 100);

      const timer = setTimeout(() => {
        window.location.href = "/";
      }, 5000);

      return () => {
        clearTimeout(timer);
        clearInterval(interval);
      };
    }
  }, [showLoadingVideo]);

  return (
    <div className="login-page ">
      {showLoadingVideo && (
        <div className="login-loading-video">
          <video
            className="login-loading-video__video"
            autoPlay
            muted
            playsInline
          >
            <source src="/assets/bg_loading.mp4" type="video/mp4" />
          </video>
          <div className="login-loading-video__overlay">
            <div className="login-loading-video__modal">
              <div className="login-loading-video__title">
                ĐANG TRUY CẬP VÀO HỆ THỐNG
              </div>
              <div className="login-loading-video__battery">
                <div className="login-loading-video__battery-body">
                  <div
                    className="login-loading-video__battery-fill"
                    style={{ width: `${loadingPercent}%` }}
                  />
                  <div className="login-loading-video__battery-percent">
                    {loadingPercent}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Background Video */}
      <video 
        className="bgLogin"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/assets/bg-mb.mp4" type="video/mp4" media="(max-width: 768px)" />
        <source src="/assets/BG_PC.mp4" type="video/mp4" />
        <source src="/assets/bg-pc.mp4" type="video/mp4" />
      </video>

      <div className="login-simple" aria-label="login actions">
        <img
          src={getAssetUrl("/assets/logo.png")}
          alt="Logo"
          className="login-simple__logo"
          draggable={false}
        />

        <div className="login-simple__actions">
          <img
            src={getAssetUrl("/assets/btn-login.png")}
            alt="Đăng nhập"
            className="login-simple__btn"
            onClick={() => setIsShowLoginForm(true)}
            role="button"
            draggable={false}
          />
          <img
            src={getAssetUrl("/assets/btn-register.png")}
            alt="Đăng ký"
            className="login-simple__btn"
            onClick={() => setIsRegister(true)}
            role="button"
            draggable={false}
          />
        </div>
      </div>

      <div
        className={`model-group ${
          isShowLoginForm || isRegister || isLogin ? "active" : ""
        }`}
      >
        <div className="overlay"></div>

        {/* Login Modal */}
        <div
          className={`model-item model-login ${
            isShowLoginForm || isLogin ? "model-login_active" : ""
          }  `}
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL || ""}/assets/modal-login.png)`,
          }}
        >
          <div
            className="btn-closeModel"
            onClick={() => {
              setIsShowLoginForm(false);
              setIsLogin(false);
            }}
          ></div>
          <img
            src={getAssetUrl("/assets/text-login.png")}
            alt="Đăng nhập"
            className="miniTxt img-title-login"
          />

          <div className="wrapper">
            <div className="title mb-2"></div>
            <form
              id="loginform"
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              <input
                className="bg-input mb-3"
                type="text"
                id="txtUsername"
                placeholder="Tên đăng nhập"
                onChange={(e) => setUserName(e.target.value)}
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <input
                className="bg-input mb-3"
                type="password"
                id="txtPassword"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mật khẩu"
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <div className="group-btn mt-4">
                <button type="button" className="btn-cancel">Hủy</button>
                <button
                  type="submit"
                  className="btn-confirm"
                >
                  Đồng ý
                </button>
              </div>
            </form>
            <p className="txt-swith">
              Chưa có tài khoản?{" "}
              <span
                className="link-register"
                onClick={() => {
                  setIsShowLoginForm(false);
                  setIsRegister(true);
                }}
              >
                Đăng ký ngay
              </span>
            </p>
          </div>
        </div>

        {/* Register Modal */}
        <Register
          isRegister={isRegister}
          setIsShowLogin={() => setIsLogin(true)}
          setIsRegister={() => setIsRegister(false)}
        />
      </div>
    </div>
  );
};

export default Login;
